import { RecipeIngredientType } from "~/types/recipe/RecipeIngredientType";

export const IngredientEntity = function (data: any): RecipeIngredientType {
    return {
        id: data?.id,
        title: data?.attributes?.title,
    };
};